export default {
	siteSeoAnalysisStart: '/site-seo-analysis/start', // 开始检测
	siteSeoAnalysisResults: '/site-seo-analysis/results/{id}', // 获取检测结果
	siteSeoAnalysisMySiteReport: '/site-seo-analysis/my-site-report', // 我的网站报告
};
